import { METAMASK_DOWNLOAD_URL, METAMASK_FLASK_DOWNLOAD_URL } from '@/constants/wallet-links';
import { WalletType } from '@/context/types';

import { getMetaMaskConnectionMode, type MetaMaskConnectionMode, setMetaMaskConnectionMode } from './metamask-connection-mode';
import { findMetaMaskProviders } from './metamask-provider';
import { detectMetaMaskProvider, hasMetaMaskProvider } from './snap-wallet-reader';

let connectionPending = false;

/** Connect from the user's click, or take them to installation if MetaMask is missing. */
export async function connectMetaMask(
  connect: (walletType: WalletType) => Promise<boolean>,
  mode: MetaMaskConnectionMode = 'default',
): Promise<boolean> {
  if (connectionPending) return false;
  connectionPending = true;
  const previousMode = getMetaMaskConnectionMode();
  let connected = false;
  try {
    setMetaMaskConnectionMode(mode);
    const installed =
      mode === 'flask' ? (await findMetaMaskProviders(250, 'flask')).length > 0 : hasMetaMaskProvider() || (await detectMetaMaskProvider());
    if (!installed) {
      window.open(mode === 'flask' ? METAMASK_FLASK_DOWNLOAD_URL : METAMASK_DOWNLOAD_URL, '_blank', 'noopener,noreferrer');
      return false;
    }
    connected = await connect(WalletType.Metamask);
    return connected;
  } finally {
    if (!connected) setMetaMaskConnectionMode(previousMode);
    connectionPending = false;
  }
}
